import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";

import { FaChevronLeft } from "react-icons/fa6";

import { OrderDeliveryContainer } from "./styled";

import SectionHeader from "../common/sectionTitle";
import StatusStepper from "./orderDelivery/statusStepper";
import ProductList from "./orderDelivery/productList";
import CourierInfo from "./orderDelivery/courierInfo";
import DeliveryLogs from "./orderDelivery/deliveryLogs";
import OrderProgress from "./orderDelivery/orderProgress";

const OrderDelivery = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const user = useSelector((state) => state?.user?.data[0]);

  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {
    const url = "/erp/customerOrder/get";
    const body = { id: orderId };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        const data = res.data;
        if (data.mberNo !== user?.mberNo) {
          throw new Error("잘못된 접근");
        }
        setOrderData(data);
      }
    } catch (error) {
      toast.error("잘못된 접근입니다.");
      navigate("/shop/mypage/history");
    }
  };

  const deliveryLogs = [
    { location: "부천(집)", status: "배송완료", time: "05/08(목) 20:36" },
    { location: "종로", status: "간선상차", time: "05/08(목) 20:36" },
    { location: "종로", status: "간선상차", time: "05/08(목) 20:36" },
    { location: "종로", status: "간선상차", time: "05/08(목) 20:36" },
    { location: "종로", status: "간선상차", time: "05/08(목) 20:36" },
    { location: "종로", status: "입고", time: "05/08(목) 20:36" },
  ];

  return (
    <OrderDeliveryContainer>
      <h2>
        {isMobile && (
          <button onClick={() => navigate(`/shop/mypage/history`)}>
            <FaChevronLeft />
          </button>
        )}
        <span>배송조회</span>
      </h2>

      <SectionHeader title={moment(orderData?.createdAt).format("YYYY.MM.DD 주문")} withLine />

      <div className="contents">
        <div className="section">
          <StatusStepper currentStatus="SHIPPING_START" />
          <ProductList subOrders={orderData?.subOrders || []} />
          <CourierInfo />
        </div>
        <div className="section">
          <OrderProgress />
          <DeliveryLogs logs={deliveryLogs} />
        </div>
      </div>
    </OrderDeliveryContainer>
  );
};

export default OrderDelivery;
